"use client";

import { CircularButtonProps } from "@/components/CircularButton";
import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { themeColors } from "@/utils/themeColors";
import { ItemType } from "@knowt/syncing/graphql/schema";
import { useRouter } from "@bprogress/next";
import { useSetEditingContextSelector } from "../hooks/useSetEditingContext";
import { wait } from "@knowt/syncing/utils/genericUtils";
import { useContentItemsSharingPopupContextSelector } from "@/features/ShareSettings/hooks/useContentItemsSharingContext";
import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import { ClassDashboardTab } from "@/features/UserContentManagement/ClassPage/types";

const SetSaveHandlerBtn = ({ ...btnProps }: CircularButtonProps) => {
    const router = useRouter();
    const { isTeacher } = useCurrentUser();

    const flashcardSet = useSetEditingContextSelector(s => s.flashcardSet);
    const isCreateMode = !!flashcardSet?.draft;
    const handleSave = useSetEditingContextSelector(s => s.handleSave);
    const isSaving = useSetEditingContextSelector(s => s.isSaving);
    const flashcardSetId = flashcardSet?.flashcardSetId;
    const openContentItemsSharingPopup = useContentItemsSharingPopupContextSelector(
        s => s.openContentItemsSharingPopup
    );

    const handleClick = async () => {
        const saveSuccessful = await handleSave();

        if (!saveSuccessful) return;

        if (isTeacher && isCreateMode && !flashcardSet?.noteId) {
            openContentItemsSharingPopup({
                flashcardSets: flashcardSet ? [flashcardSet] : undefined,
                itemType: ItemType.FLASHCARDSET,
                onSaved: () => router.replace(`/flashcards/${flashcardSetId}?isNew=true`),
                onClose: () => router.replace(`/flashcards/${flashcardSetId}?isNew=true`),
            });
            return;
        }

        await wait(1_000);
        const url =
            isTeacher && flashcardSet?.classId
                ? `/class/${flashcardSet?.classId}/dashboard?tab=${ClassDashboardTab.MATERIALS}&itemId=${flashcardSetId}&itemType=${ItemType.FLASHCARDSET}`
                : `/flashcards/${flashcardSetId}?isNew=${isCreateMode ? "true" : "false"}`;

        router.replace(url);
    };

    return (
        <CircularRectTextButton
            onClick={handleClick}
            className={"secondaryTextBold1"}
            disabled={isSaving}
            LoadingProps={{ color: "#000000" }}
            sx={{
                color: themeColors.primaryDark,
                backgroundColor: themeColors.primary,
                height: "4rem",
                "&:hover": {
                    backgroundColor: themeColors.interactiveBorder,
                    color: themeColors.neutralBlack,
                },
                gap: "0.5rem",
                padding: "0.8rem 1.6rem",
            }}
            {...btnProps}>
            {isCreateMode ? "Save & Create" : "Save"}
        </CircularRectTextButton>
    );
};

export default SetSaveHandlerBtn;
